/**
 * Central "session ended" signal (audit W02).
 *
 * Network code cannot import the Redux store without creating import cycles,
 * so the app registers one handler at startup (InitialState) and every 401 —
 * HTTP or socket — goes through it. The handler dispatches sign-out, which
 * clears persisted auth, the cached token and the socket connection.
 */
type Handler = () => void;

let handler: Handler | null = null;
let pending = false;

export function onSessionExpired(next: Handler | null) {
  handler = next;
}

/**
 * The API answers 401 "Email (or Phone number) verification is required"
 * for a valid session whose account is not verified yet. That is not an
 * expired session: signing out there sent new accounts from sign-up straight
 * to the login page instead of the verify page.
 */
export function isVerificationRequired(message: unknown): boolean {
  return typeof message === "string" && /verification is required/i.test(message);
}

export function notifySessionExpired() {
  // Several requests can fail at once; sign out only once.
  if (pending) return;
  pending = true;
  setTimeout(() => {
    pending = false;
  }, 1000);
  handler?.();
}
